<div class="kodit-card-tab">
  <kodit-racun-saldo
    [vrstaRacuna]="vrstaRacunaIzlazni"
    [tipRacuna]="selectedTipRacuna"
  ></kodit-racun-saldo>

  <div class="p-mt-3">
    <p-tabView
      [(activeIndex)]="activeIndex"
      (activeIndexChange)="handleIndexChange($event)"
    >
      <p-tabPanel
        #Fakture
        header="Fakture"
        *ngIf="shouldDisplayFakture"
      ></p-tabPanel>
      <p-tabPanel
        #Avansni
        header="Avansni računi"
        *ngIf="shouldDisplayAvansne"
      ></p-tabPanel>
      <p-tabPanel
        #DOS
        header="Dokumenti o smanjenju"
        *ngIf="shouldDisplayKO"
      ></p-tabPanel>
      <p-tabPanel
        #KZ
        header="Dokumenti o povećanju"
        *ngIf="shouldDisplayKZ"
      ></p-tabPanel>
      <p-tabPanel
        #KOMP
        header="Kompenzacije"
        *ngIf="shouldDisplayKomp"
      ></p-tabPanel>
    </p-tabView>
  </div>
  <div [ngSwitch]="activeIndex">
    <div *ngSwitchCase="0">
      <kodit-racun-table
        [tipRacuna]="tipIzlaznaFaktura"
        [vrstaRacuna]="vrstaRacunaIzlazni"
        joyrideStep="test1"
      ></kodit-racun-table>
    </div>
    <div *ngSwitchCase="1">
      <kodit-racun-table [tipRacuna]="tipAvansniRacun" [vrstaRacuna]="vrstaRacunaIzlazni"></kodit-racun-table>
    </div>
    <div *ngSwitchCase="2">
      <kodit-racun-table [tipRacuna]="tipOdobrenje" [vrstaRacuna]="vrstaRacunaIzlazni"></kodit-racun-table>
    </div>
    <div *ngSwitchCase="3">
      <kodit-racun-table [tipRacuna]="tipZaduzenje" [vrstaRacuna]="vrstaRacunaIzlazni"></kodit-racun-table>
    </div>
    <div *ngSwitchCase="4">
      <kodit-kompenzacija-table></kodit-kompenzacija-table>
    </div>
  </div>
</div>
